module.exports = __webpack_public_path__ + "static/media/lamb-curry.8d2ccbed.jpeg";